import { render, staticRenderFns } from "./TiltCard3.vue?vue&type=template&id=4bc94f50&scoped=true&lang=pug"
import script from "./TiltCard3.vue?vue&type=script&lang=js"
export * from "./TiltCard3.vue?vue&type=script&lang=js"
import style0 from "./TiltCard3.vue?vue&type=style&index=0&id=4bc94f50&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc94f50",
  null
  
)

export default component.exports